import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

const { SWIVU_SENTRY_KEY } = import.meta.env;

const isLogRocketEnabled = Boolean(SWIVU_SENTRY_KEY);

// for now we don't have any other method to check for if it's a localhost
if (isLogRocketEnabled) {
  console.log("Enabling LogRocket Analytics...");

  LogRocket.init('3wnapj/swivu');

  setupLogRocketReact(LogRocket);

}

export const addUserIdentifyToLogRocket = (user) => {
  if (!isLogRocketEnabled || !user?.id) return;

  LogRocket.identify(String(user.id), {
    name: `${user.first_name} ${user.last_name}`,
    email: user.email,
    token: user.token
  });
}

/** End the current session so the next login is not attributed to the previous user. */
export const resetLogRocketSession = () => {
  if (!isLogRocketEnabled) return;
  LogRocket.startNewSession();
}

/** WebSocket traffic is not recorded by LogRocket automatically, so it's logged manually. */
export const logSocketMessage = (label, payload) => {
  if (!isLogRocketEnabled) return;
  try {
    LogRocket.log(`[ws] ${label}`, payload);
  } catch {
    // never let logging break the socket
  }
}

export const trackSocketEvent = (eventName, properties) => {
  if (!isLogRocketEnabled) return;
  try {
    LogRocket.track(eventName, properties);
  } catch {
    // never let logging break the socket
  }
}
